export function useRole() {
  // userType en localStorage es solo para decisiones de UI (visibilidad de menús).
  // La autorización real la verifica el backend en cada request mediante la cookie httpOnly.
  // Este valor puede ser manipulado desde DevTools sin consecuencias de seguridad reales.
  const userType = localStorage.getItem("userType") || "user";

  const isAdmin   = userType === "admin";
  const isOrgAdmin = userType === "orgAdmin";
  const isUser    = userType === "user";
  const canWrite  = userType === "orgAdmin" || userType === "admin";

  const canSee = (permission) => {
    const rules = {
      "ver-encuestas": isAdmin,
      "ver-contactos": true,
    };

    return !!rules[permission];
  };

  return { userType, isAdmin, isOrgAdmin, isUser, canWrite, canSee };
}
